"use strict";
/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AreaPolygon$ = exports.AreaPolygon$outboundSchema = exports.AreaPolygon$inboundSchema = exports.Epsg4326Polygon$ = exports.Epsg4326Polygon$outboundSchema = exports.Epsg4326Polygon$inboundSchema = void 0;
exports.epsg4326PolygonToJSON = epsg4326PolygonToJSON;
exports.epsg4326PolygonFromJSON = epsg4326PolygonFromJSON;
exports.areaPolygonToJSON = areaPolygonToJSON;
exports.areaPolygonFromJSON = areaPolygonFromJSON;
const z = __importStar(require("zod"));
const primitives_js_1 = require("../../../lib/primitives.js");
const schemas_js_1 = require("../../../lib/schemas.js");
const geometrycollectionmodel_js_1 = require("./geometrycollectionmodel.js");
const linestringmodel_js_1 = require("./linestringmodel.js");
const multilinestringmodel_js_1 = require("./multilinestringmodel.js");
const multipolygonmodel_js_1 = require("./multipolygonmodel.js");
const pointmodel_js_1 = require("./pointmodel.js");
const polygonmodel_js_1 = require("./polygonmodel.js");
/** @internal */
exports.Epsg4326Polygon$inboundSchema = z.union([
    polygonmodel_js_1.PolygonModel$inboundSchema,
    multipolygonmodel_js_1.MultiPolygonModel$inboundSchema,
    geometrycollectionmodel_js_1.GeometryCollectionModel$inboundSchema,
    linestringmodel_js_1.LineStringModel$inboundSchema,
    multilinestringmodel_js_1.MultiLineStringModel$inboundSchema,
]);
/** @internal */
exports.Epsg4326Polygon$outboundSchema = z.union([
    polygonmodel_js_1.PolygonModel$outboundSchema,
    multipolygonmodel_js_1.MultiPolygonModel$outboundSchema,
    geometrycollectionmodel_js_1.GeometryCollectionModel$outboundSchema,
    linestringmodel_js_1.LineStringModel$outboundSchema,
    multilinestringmodel_js_1.MultiLineStringModel$outboundSchema,
]);
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
var Epsg4326Polygon$;
(function (Epsg4326Polygon$) {
    /** @deprecated use `Epsg4326Polygon$inboundSchema` instead. */
    Epsg4326Polygon$.inboundSchema = exports.Epsg4326Polygon$inboundSchema;
    /** @deprecated use `Epsg4326Polygon$outboundSchema` instead. */
    Epsg4326Polygon$.outboundSchema = exports.Epsg4326Polygon$outboundSchema;
})(Epsg4326Polygon$ || (exports.Epsg4326Polygon$ = Epsg4326Polygon$ = {}));
function epsg4326PolygonToJSON(epsg4326Polygon) {
    return JSON.stringify(exports.Epsg4326Polygon$outboundSchema.parse(epsg4326Polygon));
}
function epsg4326PolygonFromJSON(jsonString) {
    return (0, schemas_js_1.safeParse)(jsonString, (x) => exports.Epsg4326Polygon$inboundSchema.parse(JSON.parse(x)), `Failed to parse 'Epsg4326Polygon' from JSON`);
}
/** @internal */
exports.AreaPolygon$inboundSchema = z.object({
    boundary_area_square_metres: z.number().int(),
    class_of_title_code: z.string(),
    class_of_title_text: z.string(),
    distance_from_point: z.nullable(z.number().int()),
    epsg_4326_polygon: z.nullable(z.union([
        polygonmodel_js_1.PolygonModel$inboundSchema,
        multipolygonmodel_js_1.MultiPolygonModel$inboundSchema,
        geometrycollectionmodel_js_1.GeometryCollectionModel$inboundSchema,
        linestringmodel_js_1.LineStringModel$inboundSchema,
        multilinestringmodel_js_1.MultiLineStringModel$inboundSchema,
    ])),
    estate_interest_code: z.string(),
    estate_interest_text: z.string(),
    polygon_centre: z.nullable(pointmodel_js_1.PointModel$inboundSchema),
    polygon_date: z.string().datetime({ offset: true }).transform(v => new Date(v)),
    polygon_id: z.string(),
    title_no: z.string(),
    title_type: z.string(),
    uprn: z.nullable(z.string()),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        "boundary_area_square_metres": "boundaryAreaSquareMetres",
        "class_of_title_code": "classOfTitleCode",
        "class_of_title_text": "classOfTitleText",
        "distance_from_point": "distanceFromPoint",
        "epsg_4326_polygon": "epsg4326Polygon",
        "estate_interest_code": "estateInterestCode",
        "estate_interest_text": "estateInterestText",
        "polygon_centre": "polygonCentre",
        "polygon_date": "polygonDate",
        "polygon_id": "polygonId",
        "title_no": "titleNo",
        "title_type": "titleType",
    });
});
/** @internal */
exports.AreaPolygon$outboundSchema = z.object({
    boundaryAreaSquareMetres: z.number().int(),
    classOfTitleCode: z.string(),
    classOfTitleText: z.string(),
    distanceFromPoint: z.nullable(z.number().int()),
    epsg4326Polygon: z.nullable(z.union([
        polygonmodel_js_1.PolygonModel$outboundSchema,
        multipolygonmodel_js_1.MultiPolygonModel$outboundSchema,
        geometrycollectionmodel_js_1.GeometryCollectionModel$outboundSchema,
        linestringmodel_js_1.LineStringModel$outboundSchema,
        multilinestringmodel_js_1.MultiLineStringModel$outboundSchema,
    ])),
    estateInterestCode: z.string(),
    estateInterestText: z.string(),
    polygonCentre: z.nullable(pointmodel_js_1.PointModel$outboundSchema),
    polygonDate: z.date().transform(v => v.toISOString()),
    polygonId: z.string(),
    titleNo: z.string(),
    titleType: z.string(),
    uprn: z.nullable(z.string()),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        boundaryAreaSquareMetres: "boundary_area_square_metres",
        classOfTitleCode: "class_of_title_code",
        classOfTitleText: "class_of_title_text",
        distanceFromPoint: "distance_from_point",
        epsg4326Polygon: "epsg_4326_polygon",
        estateInterestCode: "estate_interest_code",
        estateInterestText: "estate_interest_text",
        polygonCentre: "polygon_centre",
        polygonDate: "polygon_date",
        polygonId: "polygon_id",
        titleNo: "title_no",
        titleType: "title_type",
    });
});
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
var AreaPolygon$;
(function (AreaPolygon$) {
    /** @deprecated use `AreaPolygon$inboundSchema` instead. */
    AreaPolygon$.inboundSchema = exports.AreaPolygon$inboundSchema;
    /** @deprecated use `AreaPolygon$outboundSchema` instead. */
    AreaPolygon$.outboundSchema = exports.AreaPolygon$outboundSchema;
})(AreaPolygon$ || (exports.AreaPolygon$ = AreaPolygon$ = {}));
function areaPolygonToJSON(areaPolygon) {
    return JSON.stringify(exports.AreaPolygon$outboundSchema.parse(areaPolygon));
}
function areaPolygonFromJSON(jsonString) {
    return (0, schemas_js_1.safeParse)(jsonString, (x) => exports.AreaPolygon$inboundSchema.parse(JSON.parse(x)), `Failed to parse 'AreaPolygon' from JSON`);
}
//# sourceMappingURL=areapolygon.js.map